import ApartmentIcon from '@mui/icons-material/Apartment';

const OrganizationIcon = (props) => {
    const {...other} = props;
    return (
        <ApartmentIcon {...other}/>
    )
}

export default OrganizationIcon;